// The beam is a soft arc of assembly-blue-400 that fades out on both sides.
const BEAM_GRADIENT =
  'conic-gradient(from 0deg, transparent 0deg, color-mix(in srgb, var(--color-assembly-blue-400) 50%, transparent) 40deg, var(--color-assembly-blue-400) 80deg, color-mix(in srgb, var(--color-assembly-blue-400) 50%, transparent) 120deg, transparent 160deg, transparent 360deg)';

/**
 * A light beam that orbits the edge of its `group` parent on hover, behind a
 * soft white inner glow. The parent must be `relative` and clip its overflow.
 */
export const LightBeam = () => (
  <>
    <span
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-1/2 aspect-square w-[200%] -translate-x-1/2 -translate-y-1/2 animate-spin opacity-0 blur-[4px] transition-opacity duration-300 [animation-duration:4.5s] group-hover:opacity-100 motion-reduce:animate-none"
      style={{ background: BEAM_GRADIENT }}
    />
    <span
      aria-hidden="true"
      className="pointer-events-none absolute inset-[5px] rounded-[6px] bg-white blur-[5px]"
    />
  </>
);
